module.exports = __webpack_public_path__ + "static/media/logo_transparent_cut.3feb8476.png";